export default "__VITE_PUBLIC_ASSET__9dfe6378__"